export default "__VITE_ASSET__deac8c37__$_?component__"